import { render } from "./ResetPasswordForm.vue?vue&type=template&id=786a4a8c&ts=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__